import { gtm_aam } from './analytics-gtm';
import {getCookieValue} from "@cms/utils/lib/cookie";

function gtag(..._args: unknown[]) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
}

const dataLayerPush = (arg: any) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arg);
};

const getConsentObject = (value: string) => {
    const isCookieMarketing = value === '2';
    const isCookieAnalytics = value === '3';
    const isCookieAllAccept = value === '4';

    return {
        'ad_storage': isCookieMarketing || isCookieAllAccept ? 'granted' : 'denied',
        'ad_user_data': isCookieMarketing || isCookieAllAccept ? 'granted' : 'denied',
        'ad_personalization': isCookieMarketing || isCookieAllAccept ? 'granted' : 'denied',
        'analytics_storage': isCookieAnalytics || isCookieAllAccept ? 'granted' : 'denied',
    };
};

const updateConsent = (value: string) => gtag('consent', 'update', getConsentObject(value));

export const analyticsDataLayerConsent = (() => {
    let firstCall = true;
    let value: string;

    const getNewValue = () => getCookieValue("cookiePolicyGDPR");
    const setValue = (valueArg: string) => { value = valueArg; };
    const updateValue = () => setValue(getNewValue());

    return () => {
        if (firstCall) {
            firstCall = false;
            updateValue();

            gtag('consent', 'default', getConsentObject(value));
            dataLayerPush({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' });

            window.addEventListener('onCookiePolicyChange', (event: CustomEvent) => {
                // NOTE The event is triggered after the cookie value is set, so document.cookies already has the new value.
                // The event is triggered after the cookie value is set even if the value has not changed.
                setValue(event.detail.cookiePolicyGDPRValue);
                updateConsent(value);
            });
        } else {
            const newValue = getNewValue();
            if (newValue !== value) {
                setValue(newValue);
                updateConsent(value);
            }
        }
    }
})();

const pushAbTestEvent = (): void => {

    const contentElement = document.querySelector<HTMLElement>(
        "[data-ab-test-uid][data-ab-test-version]"
    );

    if (!contentElement) {
        return;
    }

    const testUid = contentElement.dataset.abTestUid;
    const versionNumber = contentElement.dataset.abTestVersion;

    if (!testUid || !versionNumber) {
        return;
    }

    const event = {
        event: "experiment",
        experimentId: testUid,
        experimentVersion: versionNumber
    };

    dataLayerPush(event);
};

const handlerUpdateLayerYT = (): void => {
    const cookiePolicyGDPRValue = getCookieValue("cookiePolicyGDPR");
    const isCookieAllConsents = cookiePolicyGDPRValue === "4";

    // Muszę wiedzieć czy iframe jest widoczny w viewportu, muszę ręcznie go zamknąć jeżeli użytkownik zamyka okienko
    let visibilityObserver: IntersectionObserver | null = null;

    if ("IntersectionObserver" in window) {
        visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const iframe = entry.target as HTMLIFrameElement;
                const wasVisible = iframe.dataset.ytWasVisible === "true";
                const baseSrc = iframe.dataset.ytBaseSrc || "";

                if (entry.isIntersecting) {
                    // sprawdzam czy iframe "wszedł" w viewport
                    // zaznaczam, że BYŁ już kiedykolwiek widoczny - wazne zeby nadal wysyłal do dataLayer

                    iframe.dataset.ytWasVisible = "true";

                    // przywracam src (tylko jeśli go nie ma, żeby nie mielić w kółko)
                    if (!iframe.getAttribute("src") && baseSrc) {
                        iframe.setAttribute("src", baseSrc);
                    }

                } else {
                    // iframe wyszedł z viewportu

                    // To teraz chcę mu usunąć src
                    // ale dopiero JEŚLI był już kiedyś widoczny (drugi i kolejne razy)
                    // to jedyna metoda żeby go zatrzymać
                    if (wasVisible) {
                        iframe.removeAttribute("src");
                    }
                }
            });
        }, { threshold: 0.1, });
    }

    const allContainers = document.querySelectorAll('.box_yt_nocookie');

    allContainers.forEach(container => {
        const iframe = container.querySelector('iframe') as HTMLIFrameElement | null;
        const overlay = container.querySelector('.youtube-overlay') as HTMLElement | null;

        if (!iframe || !overlay) {
            return;
        }

        if (isCookieAllConsents) {
            // Ustalam bazowy src do przywracania, manipuluje stop/autoplay w zależności od tego czy jest widoczny
            const currentSrc =
                iframe.getAttribute('src') ||
                iframe.getAttribute('data-yt-base-src') ||
                '';

            if (currentSrc && !iframe.dataset.ytBaseSrc) {
                iframe.dataset.ytBaseSrc = currentSrc;
            }

            // Podpinam observer do konkretnego iframe
            if (visibilityObserver) {
                visibilityObserver.observe(iframe);
            }

            const iframeTitle = iframe.getAttribute('title') || '';
            const videoId = iframe.getAttribute('data-id-yt');

            overlay.style.display = 'block';
            overlay.addEventListener('click', (event) => {
                event.preventDefault();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                                          event: 'pwaVideoYT',
                                          videoID: videoId,
                                          videoTitle: iframeTitle,
                                      });

                const baseSrc = iframe.dataset.ytBaseSrc || iframe.getAttribute('src') || '';
                if (!baseSrc) return;

                const newSrc = baseSrc.includes('?') ? baseSrc + "&autoplay=1" : baseSrc + "?autoplay=1";

                iframe.setAttribute('src', newSrc);
                overlay.style.display = 'none';
                iframe.style.pointerEvents = 'auto';
            });

            iframe.style.pointerEvents = 'none';
        } else {
            overlay.style.display = 'none';
            iframe.style.pointerEvents = 'auto';
        }
    });
};


export function analyticsDataLayerYT() {
    handlerUpdateLayerYT();

    window.addEventListener('onCookiePolicyChange', (event: CustomEvent) => {
         handlerUpdateLayerYT();
    });
}

export function analyticsDataLayer() {
    const pathName = document.location.pathname;
    const locationHref = document.location.href;
    const documentTitle = document.title;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'pwaPageView',
        'title': documentTitle,
        'location': locationHref,
        'page': pathName
    });

    if (gtm_aam()) {
        window._gtm_aam_data = gtm_aam();
    }

    window.dataLayer.push({
        'event': 'pwaHeaderView'
    });
}

const handlerUpdateLayerAbTest = (): void => {
    const cookiePolicyGDPRValue = getCookieValue("cookiePolicyGDPR");
    const hasAnalyticsConsent =
        cookiePolicyGDPRValue === "3" ||
        cookiePolicyGDPRValue === "4";

    if (!hasAnalyticsConsent) {
        return;
    }

    pushAbTestEvent();
};

let abTestCookieListenerAdded = false;

export function analyticsDataLayerAbTest(): void {
    handlerUpdateLayerAbTest();

    if (abTestCookieListenerAdded) {
        return;
    }

    abTestCookieListenerAdded = true;

    window.addEventListener("onCookiePolicyChange", () => {
        handlerUpdateLayerAbTest();
    });
}

export function createDataLayerPushTimer () {
    const pushTimeout = 5000;
    let timerId: number = null;
    window.dataLayer = window.dataLayer || [];
    function dataLayerPushTimer () {
        if (timerId !== null) {
            window.clearTimeout(timerId);
        }
        timerId = window.setTimeout(function () {
            window.dataLayer.push({
                'event': 'pwaTimer',
                'pwaTimeOnSite': 5
            });
        }, pushTimeout);
    }
    return dataLayerPushTimer;
}

export function addListenerAnalyticScrollDepth() {
    var storageScrollDepth = '0',
        pageCompletelyScrolled = false;

    function resetStorageScrollDepth() {
        storageScrollDepth = '0';
        pageCompletelyScrolled = false;
    }

    function isThresholdForCurrentDepth(currentScrollDepth: number, scrollThreshold: number) {
        return currentScrollDepth >= scrollThreshold && storageScrollDepth.indexOf(scrollThreshold.toString()) == -1
    }

    function dataLayerPushScrollDepth(percentage: number) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'pwaScrollDepth',
            'pwaScrollThreshold': percentage
        });
        storageScrollDepth += "/" + percentage;
    }

    window.addEventListener('scroll', function () {
        if (pageCompletelyScrolled) return;

        var body = document.body,
            html = document.documentElement,
            windowScrollTop = (window.pageYOffset || html.scrollTop)  - (html.clientTop || 0),
            documentHeight = Math.max( body.scrollHeight, body.offsetHeight, 
                html.clientHeight, html.scrollHeight, html.offsetHeight ),
            windowHeight = window.innerHeight
                || html.clientHeight
                || body.clientHeight,
            currentScrollDepth = Math.round((windowScrollTop / (documentHeight - windowHeight)) * 100);

        switch (true) {
            case isThresholdForCurrentDepth(currentScrollDepth, 25):
                dataLayerPushScrollDepth(25);
                break;
            case isThresholdForCurrentDepth(currentScrollDepth, 50):
                dataLayerPushScrollDepth(50);
                break;
            case isThresholdForCurrentDepth(currentScrollDepth, 75):
                dataLayerPushScrollDepth(75);
                break;
            case isThresholdForCurrentDepth(currentScrollDepth, 100):
                dataLayerPushScrollDepth(100);
                pageCompletelyScrolled = true;
                break;
            default:
                break;
        }
    });

    return resetStorageScrollDepth;
}
